// src/services/favorites.js

const KEY = 'my_favorites_groups';

export default {
  getGroups() {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { 'Default': [] };
    return JSON.parse(raw);
  },

  saveGroups(groups) {
    localStorage.setItem(KEY, JSON.stringify(groups));
  },

  // Check if an ID is in ANY group
  isFavorite(id) {
    const groups = this.getGroups();
    id = String(id);
    for (const groupName in groups) {
      if (groups[groupName].includes(id)) return true;
    }
    return false;
  },

  // Return list of groups this item belongs to
  getItemGroups(id) {
    const groups = this.getGroups();
    const foundIn = [];
    id = String(id);
    for (const groupName in groups) {
      if (groups[groupName].includes(id)) foundIn.push(groupName);
    }
    return foundIn;
  },

  addToGroup(id, groupName = 'Default') {
    const groups = this.getGroups();
    id = String(id);
    
    // Create group if missing
    if (!groups[groupName]) groups[groupName] = [];
    
    // Add only if not already in THIS specific group
    if (!groups[groupName].includes(id)) {
      groups[groupName].push(id);
    }
    
    this.saveGroups(groups);
  },

  removeFromGroup(id, groupName) {
    const groups = this.getGroups();
    id = String(id);
    if (groups[groupName]) {
      groups[groupName] = groups[groupName].filter(item => item !== id);
    }
    this.saveGroups(groups);
  },

  // Completely remove item from ALL groups
  removeFromAll(id) {
    const groups = this.getGroups();
    id = String(id);
    for (const groupName in groups) {
      groups[groupName] = groups[groupName].filter(item => item !== id);
    }
    this.saveGroups(groups);
  },
  
  createGroup(groupName) {
    const groups = this.getGroups();
    if (!groups[groupName]) {
      groups[groupName] = [];
      this.saveGroups(groups);
    }
  },

  deleteGroup(groupName) {
    const groups = this.getGroups();
    delete groups[groupName];
    // Ensure Default always exists
    if (!groups['Default']) groups['Default'] = [];
    this.saveGroups(groups);
  }
};